"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("../utils/styled"));
const Tooltip_1 = __importDefault(require("../Tooltip/Tooltip"));
const Icon_1 = require("../Icon");
const Container = styled_1.default("div")(({ left, right, theme }) => ({
    position: "relative",
    display: "inline-flex",
    verticalAlign: "middle",
    alignItems: "center",
    justifyContent: "center",
    color: theme.color.text.lightest,
    marginRight: left ? theme.space.base : 0,
    marginLeft: right ? theme.space.base : 0,
    width: 24,
}));
const Hint = props => {
    const [isTooltipVisible, setIsTooltipVisible] = React.useState(false);
    return (React.createElement(Container, Object.assign({ onMouseEnter: () => setIsTooltipVisible(true), onMouseOut: () => setIsTooltipVisible(false), "aria-label": typeof props.children === "string" ? props.children : undefined }, props),
        React.createElement(Icon_1.HelpIcon, { size: 12 }),
        isTooltipVisible && (React.createElement(Tooltip_1.default, { position: props.tooltipPosition, textId: props.textId }, props.children))));
};
Hint.defaultProps = {
    tooltipPosition: "left",
};
exports.default = Hint;
//# sourceMappingURL=Hint.js.map